import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function purchasesByGroupSubscriptionReducer(
  state = initialState.groupSubscriptionPurchases,
  action
) {
  switch (action.type) {
    case types.GET_GROUP_PURCHASES_BY_MERCHANT_CODE_SUCCESS:
      return action.groupSubscriptionPurchases;
    case types.GET_GROUP_PURCHASES_BY_MERCHANT_CODE_FAILED:
      return action.error;
    default:
      return state;
  }
}